/**
 * Package version, surfaced in the User-Agent.
 *
 * Kept as a literal rather than importing package.json so the published bundle
 * has no JSON import; `version.test.ts` asserts the two stay in sync.
 */
export const VERSION = '0.4.0';
